module.exports = __webpack_public_path__ + "img/tonix.ba540080.png";